export const CANONICAL_HOST = process.env.REACT_APP_CANONICAL_HOST || "nexustrac.org";
export const CANONICAL_ORIGIN = process.env.REACT_APP_CANONICAL_ORIGIN || "https://nexustrac.org";

// Build allowed hosts dynamically from env
const buildAllowedHosts = () => {
  const hosts = ["nexustrac.org", "www.nexustrac.org", "investigation-intel.emergent.host"];
  // Add preview host if running in preview environment
  if (typeof window !== 'undefined') {
    const currentHost = window.location.hostname.toLowerCase();
    if (currentHost && !hosts.includes(currentHost)) {
      hosts.push(currentHost);
    }
  }
  return hosts;
};

export const ALLOWED_HOSTS = buildAllowedHosts();
export const ALLOWED_ORIGINS = ["https://nexustrac.org", "https://www.nexustrac.org", "https://investigation-intel.emergent.host"];
export const API_BASE_URL = "/api";
export const BACKEND_URL = "";

export const isAllowedHost = (host) => {
  if (!host) return false;
  const hostLower = host.toLowerCase();
  // Allow production domains
  if (hostLower === "nexustrac.org" || hostLower === "www.nexustrac.org") return true;
  // Allow emergent.host production domains
  if (hostLower.endsWith('.emergent.host')) return true;
  // Allow preview domains (*.preview.emergentagent.com)
  if (hostLower.endsWith('.preview.emergentagent.com')) return true;
  // Allow localhost for development
  if (hostLower === 'localhost' || hostLower === '127.0.0.1') return true;
  return ALLOWED_HOSTS.includes(hostLower);
};

export const resolveApiUrl = (path) => {
  if (!path) return API_BASE_URL;
  if (path.startsWith("/")) return `${API_BASE_URL}${path}`;
  return `${API_BASE_URL}/${path}`;
};
